<ng-container *letVar="isMobile$ | async as isMobile">
    <mat-sidenav-container (backdropClick)="onMenuClose()" [class.mobile]="isMobile">
        <mat-sidenav
            #secondaryNav
            *ngIf="isNavNeeded"
            [fixedInViewport]="!isMobile"
            [opened]="isMenuOpened"
            [mode]="isMobile ? 'over' : 'side'"
        >
            <div class="secondary-menu-wrapper">
                <div [ngClass]="isMobile ? 'menu-header-mobile' : 'menu-header'">
                    {{ menuHeader }}
                    <div class="menu-header-text">
                        {{ menuHeaderText }}
                    </div>
                </div>
                <div class="menu-toggle-wrapper" *ngIf="!isMobile" (click)="toggleSecondaryMenu()">
                    <div class="menu-toggle">
                        <mat-icon class="menu-icon fp-icon-left-chevron"></mat-icon>
                    </div>
                </div>
                <ng-content select="[secondaryNav]"> </ng-content>
            </div>
        </mat-sidenav>
        <mat-sidenav-content>
            <div class="menu-toggle-wrapper" *ngIf="!isMobile && isNavNeeded && !isMenuOpened" (click)="toggleSecondaryMenu()">
                <div class="menu-toggle">
                    <mat-icon class="menu-icon fp-icon-right-chevron"></mat-icon>
                </div>
            </div>
            <div class="main-content">
                <ng-content select="[mainContent]"> </ng-content>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</ng-container>
